import {NgModule} from '@angular/core';
import { Router } from '@angular/router';
import { CanActivate } from '@angular/router';
import { AuthService } from './auth.service';


@NgModule({
  providers: []
})

export class LoginGuard implements CanActivate {

  constructor(private auth: AuthService, private router: Router) {}

  canActivate() {
    if (this.auth.loggedIn()) {
      this.router.navigate(['/freelancers']);
    }
    return true;
  }
}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/login-guard.service.ts